import dayjs from 'dayjs';

/** Todos monthly calendar (replaces legacy todos list). */
export function todosCalendarPath(
  date?: string | Date,
  options?: { showAppointments?: boolean },
): string {
  const d = date ? dayjs(date).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
  const appointments = options?.showAppointments ? '1' : '0';
  return `/todos_monthly_view?view=month&date=${d}&openOnly=1&appointments=${appointments}`;
}

/** Primary sidebar entry for Todos — always opens todos-only mode (not appointments overlay). */
export function todosSidebarPath(date?: string | Date): string {
  return todosCalendarPath(date, { showAppointments: false });
}
